import { UserModel } from '@app/domain/UserModel';
const avatarImg = process.env.REACT_APP_ASSETS_BUCKET + '/avatars/avatar5.webp';

const testUser = {
  id: 1222,
  fullName: 'Long',
  lastName: 'Tran',
  imgUrl: avatarImg,
  userName: 'longtb',
  email: {
    name: 'longtrb@gmail.com',
    verified: true,
  },
  // phone: {
  //   number: '+18143519459',
  //   verified: true,
  // },
  // sex: 'male',
  // birthday: '01/26/2022',
  // lang: 'en',
  // country: 'GB',
  // city: 'London',
  // address1: '14 London Road',
  // zipcode: 5211,
};

export const setSettingId = (title: string, factory: string): void => {
  localStorage.setItem('settingId' + factory, title);
};

export const getSettingId = (factory: string): string => {
  return localStorage.getItem('settingId' + factory) || '';
};

export const setDayColorGood = (title: string, factory: string): void => {
  localStorage.setItem('dayColorGood' + factory, title);
};

export const getDayColorGood = (factory: string): string => {
  return localStorage.getItem('dayColorGood' + factory) || '';
};

export const setDayColorWarn = (title: string, factory: string): void => {
  localStorage.setItem('dayColorWarn' + factory, title);
};

export const getDayColorWarn = (factory: string): string => {
  return localStorage.getItem('dayColorWarn' + factory) || '';
};

export const setDayColorError = (title: string, factory: string): void => {
  localStorage.setItem('dayColorError' + factory, title);
};

export const getDayColorError = (factory: string): string => {
  return localStorage.getItem('dayColorError' + factory) || '';
};

export const setLogoTitle = (title: string, factory: string): void => {
  localStorage.setItem('logoTitle' + factory, title);
};

export const getTextNoteErrorSafety = (): string => {
  return localStorage.getItem('TextNoteErrorSafty') || '';
};

export const setTextNoteErrorSafety = (title: string): void => {
  localStorage.setItem('TextNoteErrorSafty', title);
};

export const getTextNoteGoodSafety = (): string => {
  return localStorage.getItem('TextNoteGoodSafty') || '';
};

export const setTextNoteGoodSafety = (title: string): void => {
  localStorage.setItem('TextNoteGoodSafty', title);
};

export const getTextNoteWarnSafety = (): string => {
  return localStorage.getItem('TextNoteWarnSafty') || '';
};

export const setTextNoteWarnSafety = (title: string): void => {
  localStorage.setItem('TextNoteWarnSafty', title);
};

export const getTextNoteErrorQuality = (): string => {
  return localStorage.getItem('TextNoteErrorQuality') || '';
};

export const setTextNoteErrorQuality = (title: string): void => {
  localStorage.setItem('TextNoteErrorQuality', title);
};

export const getTextNoteGoodQuality = (): string => {
  return localStorage.getItem('TextNoteGoodQuality') || '';
};

export const setTextNoteGoodQuality = (title: string): void => {
  localStorage.setItem('TextNoteGoodQuality', title);
};

export const getTextNoteWarnQuality = (): string => {
  return localStorage.getItem('TextNoteWarnQuality') || '';
};

export const setTextNoteWarnQuality = (title: string): void => {
  localStorage.setItem('TextNoteWarnQuality', title);
};

export const getTextNoteErrorProductivity = (): string => {
  return localStorage.getItem('TextNoteErrorProductivity') || '';
};

export const setTextNoteErrorProductivity = (title: string): void => {
  localStorage.setItem('TextNoteErrorProductivity', title);
};

export const getTextNoteGoodProductivity = (): string => {
  return localStorage.getItem('TextNoteGoodProductivity') || '';
};

export const setTextNoteGoodProductivity = (title: string): void => {
  localStorage.setItem('TextNoteGoodProductivity', title);
};

export const getTextNoteWarnProductivity = (): string => {
  return localStorage.getItem('TextNoteWarnProductivity') || '';
};

export const setTextNoteWarnProductivity = (title: string): void => {
  localStorage.setItem('TextNoteWarnProductivity', title);
};

export const getTextNoteErrorDelivery = (): string => {
  return localStorage.getItem('TextNoteErrorDelivery') || '';
};

export const setTextNoteErrorDelivery = (title: string): void => {
  localStorage.setItem('TextNoteErrorDelivery', title);
};

export const getTextNoteGoodDelivery = (): string => {
  return localStorage.getItem('TextNoteGoodDelivery') || '';
};

export const setTextNoteGoodDelivery = (title: string): void => {
  localStorage.setItem('TextNoteGoodDelivery', title);
};

export const getTextNoteWarnDelivery = (): string => {
  return localStorage.getItem('TextNoteWarnDelivery') || '';
};

export const setTextNoteWarnDelivery = (title: string): void => {
  localStorage.setItem('TextNoteWarnDelivery', title);
};

export const getLogoTitle = (factory: string): string => {
  return localStorage.getItem('logoTitle' + factory) || '';
};

export const setLogoUrl = (url: string, factory: string): void => {
  localStorage.setItem('logoUrl' + factory, url);
};

export const getLogoUrl = (factory: string): string => {
  return localStorage.getItem('logoUrl' + factory) || '';
};

export const persistToken = (token: string): void => {
  localStorage.setItem('accessToken', token);
};

export const persistRefreshToken = (token: string): void => {
  localStorage.setItem('refreshToken', token);
};

export const readToken = (): string => {
  return localStorage.getItem('accessToken') || '';
};

export const readRefreshToken = (): string => {
  return localStorage.getItem('refreshToken') || '';
};

export const persistUser = (user: UserModel): void => {
  localStorage.setItem('user', JSON.stringify(user));
};

export const readUser = (): UserModel | null => {
  const userStr = localStorage.getItem('user');
  return userStr ? JSON.parse(userStr) : null;
};

/** Giá trị `user_name` trong payload JWT (accessToken) — tài khoản chỉ Kaizen. */
export const KAIZEN_ONLY_JWT_USER_NAME = '46a34d21-fa32-41f1-b022-b8df306cf5f0';

const decodeAccessTokenPayload = (token: string): Record<string, unknown> | null => {
  try {
    const parts = token.split('.');
    if (parts.length < 2) return null;
    let base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const pad = base64.length % 4;
    if (pad) base64 += '='.repeat(4 - pad);
    const json = atob(base64);
    return JSON.parse(json) as Record<string, unknown>;
  } catch {
    return null;
  }
};

/** Tài khoản chỉ dùng Kaizen: decode accessToken, so `user_name` với {@link KAIZEN_ONLY_JWT_USER_NAME}. */
export const isKaizenOnlyUser = (): boolean => {
  const token = readToken();
  if (!token) return false;
  const payload = decodeAccessTokenPayload(token);
  const userName = payload?.user_name;
  return typeof userName === 'string' && userName === KAIZEN_ONLY_JWT_USER_NAME;
};

export const checkRoot = (): boolean => {
  const userStr = localStorage.getItem('user');
  if (userStr) {
    return JSON.parse(userStr).isRoot;
  }
  return false;
};

/**
 * QC and Super User Email Lists (Calib)
 * These lists define authorized emails for QC and Super User roles
 */
export const QC_EMAILS: readonly string[] = [
  'thuy.nguyen-gia@hitachienergy.com',
  'thu.nguyenminh@hitachienergy.com',
  'tuong.do-duc@hitachienergy.com',
  'truong.ngo-dinh@hitachienergy.com',
  'trung.nguyen-cong@hitachienergy.com',
  'vu.nguyen-van@hitachienergy.com',
  'quynh.do-nhu@hitachienergy.com',
  'canh.nong-duc@hitachienergy.com',
] as const;

export const SUPER_USER_EMAILS: readonly string[] = [
  'dung.nguyen-thi@hitachienergy.com',
  'thuy.bui-thi@hitachienergy.com',
  'thu.nguyenminh@hitachienergy.com',
] as const;

/** Check if current user is QC based on email */
export const checkIsQC = (email?: string): boolean => {
  const userEmail = email || readUser()?.email;
  if (!userEmail || typeof userEmail !== 'string') return false;
  const emailLower = userEmail.toLowerCase().trim();
  return QC_EMAILS.some((qcEmail) => qcEmail.toLowerCase() === emailLower);
};

/** Check if current user is Super User based on email */
export const checkIsSuperUser = (email?: string): boolean => {
  const userEmail = email || readUser()?.email;
  if (!userEmail || typeof userEmail !== 'string') return false;
  const emailLower = userEmail.toLowerCase().trim();
  return SUPER_USER_EMAILS.some((e) => e.toLowerCase() === emailLower);
};

/** Check if user is QC or Super User */
export const checkIsQCOrSuperUser = (email?: string): boolean => {
  return checkIsQC(email) || checkIsSuperUser(email);
};

/** Check if user is Admin (isRoot) */
export const checkIsAdmin = (): boolean => checkRoot();

/** Calib: Sửa thông tin thiết bị - Admin, Super user */
export const canEditDeviceInfo = (): boolean => checkIsAdmin() || checkIsSuperUser();

/** Calib: Tab UPDATE CERTIFICATE - Admin (root), Super user (Quality_Dung, Quality_Thúy) */
export const canUpdateCertificate = (): boolean => checkIsAdmin() || checkIsSuperUser();

/** Calib: Tạo mới thiết bị - Admin, Super user */
export const canCreateDevice = (): boolean => checkIsAdmin() || checkIsSuperUser();

/** Calib: Cấp phát - Admin, Super user */
export const canAllocateDevice = (): boolean => checkIsAdmin() || checkIsSuperUser();

/** Calib: Thu hồi - Admin, Super user */
export const canRecallDevice = (): boolean => checkIsAdmin() || checkIsSuperUser();

/** Calib: Hiệu chuẩn - Admin, Super user */
export const canCalibrateDevice = (): boolean => checkIsAdmin() || checkIsSuperUser();

/** Calib: Sửa chữa - Admin, Super user */
export const canRepairDevice = (): boolean => checkIsAdmin() || checkIsSuperUser();

/** Calib: Báo sự cố - Tất cả */
export const canReportIncident = (): boolean => true;

/** Calib: Ngừng sử dụng - Tất cả */
export const canStopUsingDevice = (): boolean => true;

/** Calib: Hủy - Tất cả */
export const canCancelDevice = (): boolean => true;

/** Calib: Xóa thiết bị - Admin only */
export const canDeleteDevice = (): boolean => checkIsAdmin();

/** Calib: Thêm/Sửa dữ liệu - Admin, Super user */
export const canManageData = (): boolean => checkIsAdmin() || checkIsSuperUser();

/** Calib: Xóa dữ liệu - Admin only */
export const canDeleteData = (): boolean => checkIsAdmin();

/**
 * Tài khoản được phép vô hiệu hoá / kích hoạt lại user.
 * Kiểm theo tên tài khoản (không theo role) — khớp với guard phía backend
 * (ADMIN_USERNAMES trong HtcUserServiceImpl). Backend vẫn tự kiểm tra độc lập;
 * hàm này chỉ để ẩn nút, tránh gọi API rồi nhận 403.
 */
export const ADMIN_USERNAMES = ['admin', 'gemba_admin'];

export const canManageUserStatus = (): boolean => {
  const userName = readUser()?.userName;
  return !!userName && ADMIN_USERNAMES.includes(userName.toLowerCase());
};

export const deleteToken = (): void => localStorage.removeItem('accessToken');
export const deleteRefreshToken = (): void => localStorage.removeItem('refreshToken');
export const deleteUser = (): void => localStorage.removeItem('user');
